import "../styles/general.css";

import DesktopView from "../components/desktopview/DesktopView";
import Header from "../components/header/Header";

import React, { useEffect, useState } from "react";

import { GoChevronDown } from "react-icons/go";
import { FAQ_OPTIONS } from "../constants/faq";

export default function FAQ() {
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);
  const [ind, setInd] = useState(-1);
  const [flag, setFlag] = useState([1, 2]);

  const [tt, setTt] = useState([]);
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="relative w-full h-screen flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden  "
        onClick={() => {}}
      >
        <Header />
        <div className="w-full flex items-center justify-center my-[8vw]">
          <span className="text-[5vw] text-[#FFF] font-font_primary_A font-bold">
            سوالات متدوال
          </span>
        </div>
        <div
          className={`w-[90vw]  h-full flex flex-col items-start justify-start  gap-y-[2vw]  overflow-auto`}
        >
          {FAQ_OPTIONS.map((item, index) => {
            let tmp = [];
            return (
              <div
                key={index}
                className="w-full flex flex-col items-center justify-center p-[2vw] pb-[4vw]  border-b-[1px] border-[#474747] "
              >
                <div
                  className="w-full flex items-center justify-between "
                  onClick={() => {
                    setIsAnswerOpen((perv) => !perv);

                    if (tt.includes(index)) {
                      setTt(tt.filter((item) => item !== index));
                    } else {
                      setTt((prev) => [...prev, index]);
                    }
                    // setInd(index);

                    // if (ind !== index) {
                    //   setInd(index);
                    // } else {
                    //   setInd(-1);
                    // }
                  }}
                >
                  <div className="w-[95%] ">
                    <p className="w-full   font-font_primary_A text-[3.5vw] text-white font-normal text-justify pl-[3vw]   break-words">
                      {item.question}
                    </p>
                  </div>
                  <div
                    className={`w-[5%] ${
                      tt.includes(index) ? "" : "rotate-90"
                    }`}
                  >
                    <GoChevronDown size={20} color="white" />
                  </div>
                </div>
                {tt.includes(index) && (
                  <div className="w-full flex items-center justify-start pt-[2vw] pr-0 btFadeIn-WithOutDelay">
                    <p className="w-full font-font_primary_A text-[3vw] text-white font-extralight text-justify break-words">
                      {item.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
